// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/interface/buttonNormal.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.audio-player-skin {
	min-height: 137px;
	height: 137px;
	min-width: 473px;
	max-width: 473px;
	background: transparent;
	font-family: arial;
	color: white;
	display: flex;
	position: relative;
	padding: 0px 60px;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	background-repeat: no-repeat;
	background-size: contain;
	background-position: center;
	font-size: 0.75em;
	overflow: hidden;
	flex-direction: column;
	justify-content: center;
}
.musicgenres__items {
	color: #aaa;
	position: absolute;
	display: flex;
	width: 100%;
	bottom: 27px;
	right: 0;
	justify-content: center;
	gap: 250px;
	font-size: 15px;
	text-transform: capitalize;
	position: absolute;
	z-index: 110;
	pointer-events: auto;
}
.active-text {
	color: white !important;
}
.timeline {
	background: white;
	width: 80%;
	height: 20px;
	margin: 0 auto;
	position: relative;
	cursor: pointer;
	box-shadow: 0 2px 10px 0 #0008;
	position: relative;
	z-index: 110;
}
.timeline-control {
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	z-index: 120;
	background: transparent;
	pointer-events: auto;
	position: relative;
}
.progress-music {
	background: #9f0505;
	width: 0%;
	height: 100%;
	transition: 0.25s;
	position: absolute;
	left: 0;
	top: 0;
	z-index: 115;
	pointer-events: none;
}
.controls {
	margin-top: 10px;
	display: flex;
	justify-content: space-around;
	align-items: stretch;
	padding: 0 20px;
}
.controls > * {
	display: flex;
	justify-content: center;
	align-items: center;
}
.toggle-play.play {
	cursor: pointer;
	position: relative;
	left: 5px;
	height: 0;
	width: 0;
	border: 7px solid #0000;
	border-left: 13px solid white;
}
.toggle-play.play:hover {
	transform: scale(1.1);
}
.toggle-play.pause {
	height: 15px;
	width: 20px;
	cursor: pointer;
	position: relative;
}
.toggle-play.pause:before {
	position: absolute;
	top: 0;
	left: 5px;
	background: white;
	content: '';
	height: 15px;
	width: 3px;
}
.toggle-play.pause:after {
	position: absolute;
	top: 0;
	right: 0px;
	background: white;
	content: '';
	height: 15px;
	width: 3px;
}
.toggle-play.pause:hover {
	transform: scale(1.1);
}
.time {
	color: black;
	font-weight: 700;
	margin-top: 0;
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	z-index: 125;
	pointer-events: none;
	background-color: transparent;
	border-radius: 0;
	padding: 0;
}
.time > * {
	padding: 2px;
}

.volumeSliders {
	position: absolute;
	bottom: 10px;
	left: 50%;
	transform: translateX(-50%);
	z-index: 100;
	display: flex;
	justify-content: center;
	gap: 70px;
	border-radius: 5px;
	width: 80%;
	pointer-events: auto;
}

#sfx-slider, #vol-slider {
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	max-width: 150px;
	margin-bottom: 70px;
}

.volume-label {
	color: white;
	font-size: 15px;
	margin-bottom: 2px;
	text-align: center;
}

input#sfx.slider, input#vol.slider {
	-webkit-appearance: none;
	width: 100%;
	height: 18px;
	cursor: pointer;
	margin: 0;
	padding: 0;
}

input#sfx.slider::-webkit-slider-thumb, input#vol.slider::-webkit-slider-thumb {
	-webkit-appearance: none;
	width: 18px;
	height: 18px;
	background: #9f0505;
	border-radius: 50%;
	cursor: pointer;
}

input#sfx.slider::-moz-range-thumb, input#vol.slider::-moz-range-thumb {
	width: 18px;
	height: 18px;
	background: #9f0505;
	border-radius: 50%;
	cursor: pointer;
	border: none;
}

input {
	background: transparent;
}

.audio-player-skin {
	position: relative;
}

/* debug controls not working */
.timeline-control, .toggle-play, .musicgenres__title {
	pointer-events: auto;
	z-index: 110; 
	position: relative;
}

.musicgenres__items {
	position: absolute;
	z-index: 110;
	pointer-events: auto;
}
`, "",{"version":3,"sources":["webpack://./src/style/skin.css"],"names":[],"mappings":"AAAA;CACC,iBAAiB;CACjB,aAAa;CACb,gBAAgB;CAChB,gBAAgB;CAChB,uBAAuB;CACvB,kBAAkB;CAClB,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB,iBAAiB;CACjB,yDAA2D;CAC3D,4BAA4B;CAC5B,wBAAwB;CACxB,2BAA2B;CAC3B,iBAAiB;CACjB,gBAAgB;CAChB,sBAAsB;CACtB,uBAAuB;AACxB;AACA;CACC,WAAW;CACX,kBAAkB;CAClB,aAAa;CACb,WAAW;CACX,YAAY;CACZ,QAAQ;CACR,uBAAuB;CACvB,UAAU;CACV,eAAe;CACf,0BAA0B;CAC1B,kBAAkB;CAClB,YAAY;CACZ,oBAAoB;AACrB;AACA;CACC,uBAAuB;AACxB;AACA;CACC,iBAAiB;CACjB,UAAU;CACV,YAAY;CACZ,cAAc;CACd,kBAAkB;CAClB,eAAe;CACf,8BAA8B;CAC9B,kBAAkB;CAClB,YAAY;AACb;AACA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,YAAY;CACZ,uBAAuB;CACvB,oBAAoB;CACpB,kBAAkB;AACnB;AACA;CACC,mBAAmB;CACnB,SAAS;CACT,YAAY;CACZ,iBAAiB;CACjB,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,YAAY;CACZ,oBAAoB;AACrB;AACA;CACC,gBAAgB;CAChB,aAAa;CACb,6BAA6B;CAC7B,oBAAoB;CACpB,eAAe;AAChB;AACA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,kBAAkB;CAClB,SAAS;CACT,SAAS;CACT,QAAQ;CACR,uBAAuB;CACvB,6BAA6B;AAC9B;AACA;CACC,qBAAqB;AACtB;AACA;CACC,YAAY;CACZ,WAAW;CACX,eAAe;CACf,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,MAAM;CACN,SAAS;CACT,iBAAiB;CACjB,WAAW;CACX,YAAY;CACZ,UAAU;AACX;AACA;CACC,kBAAkB;CAClB,MAAM;CACN,UAAU;CACV,iBAAiB;CACjB,WAAW;CACX,YAAY;CACZ,UAAU;AACX;AACA;CACC,qBAAqB;AACtB;AACA;CACC,YAAY;CACZ,gBAAgB;CAChB,aAAa;CACb,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,gCAAgC;CAChC,aAAa;CACb,YAAY;CACZ,oBAAoB;CACpB,6BAA6B;CAC7B,gBAAgB;CAChB,UAAU;AACX;AACA;CACC,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,SAAS;CACT,2BAA2B;CAC3B,YAAY;CACZ,aAAa;CACb,uBAAuB;CACvB,SAAS;CACT,kBAAkB;CAClB,UAAU;CACV,oBAAoB;AACrB;;AAEA;CACC,OAAO;CACP,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,wBAAwB;CACxB,WAAW;CACX,YAAY;CACZ,eAAe;CACf,SAAS;CACT,UAAU;AACX;;AAEA;CACC,wBAAwB;CACxB,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,kBAAkB;CAClB,eAAe;CACf,YAAY;AACb;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;AACnB;;AAEA,+BAA+B;AAC/B;CACC,oBAAoB;CACpB,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,oBAAoB;AACrB","sourcesContent":[".audio-player-skin {\n\tmin-height: 137px;\n\theight: 137px;\n\tmin-width: 473px;\n\tmax-width: 473px;\n\tbackground: transparent;\n\tfont-family: arial;\n\tcolor: white;\n\tdisplay: flex;\n\tposition: relative;\n\tpadding: 0px 60px;\n\tbackground-image: url('~assets/interface/buttonNormal.png');\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tbackground-position: center;\n\tfont-size: 0.75em;\n\toverflow: hidden;\n\tflex-direction: column;\n\tjustify-content: center;\n}\n.musicgenres__items {\n\tcolor: #aaa;\n\tposition: absolute;\n\tdisplay: flex;\n\twidth: 100%;\n\tbottom: 27px;\n\tright: 0;\n\tjustify-content: center;\n\tgap: 250px;\n\tfont-size: 15px;\n\ttext-transform: capitalize;\n\tposition: absolute;\n\tz-index: 110;\n\tpointer-events: auto;\n}\n.active-text {\n\tcolor: white !important;\n}\n.timeline {\n\tbackground: white;\n\twidth: 80%;\n\theight: 20px;\n\tmargin: 0 auto;\n\tposition: relative;\n\tcursor: pointer;\n\tbox-shadow: 0 2px 10px 0 #0008;\n\tposition: relative;\n\tz-index: 110;\n}\n.timeline-control {\n\twidth: 100%;\n\theight: 100%;\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\tz-index: 120;\n\tbackground: transparent;\n\tpointer-events: auto;\n\tposition: relative;\n}\n.progress-music {\n\tbackground: #9f0505;\n\twidth: 0%;\n\theight: 100%;\n\ttransition: 0.25s;\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\tz-index: 115;\n\tpointer-events: none;\n}\n.controls {\n\tmargin-top: 10px;\n\tdisplay: flex;\n\tjustify-content: space-around;\n\talign-items: stretch;\n\tpadding: 0 20px;\n}\n.controls > * {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n.toggle-play.play {\n\tcursor: pointer;\n\tposition: relative;\n\tleft: 5px;\n\theight: 0;\n\twidth: 0;\n\tborder: 7px solid #0000;\n\tborder-left: 13px solid white;\n}\n.toggle-play.play:hover {\n\ttransform: scale(1.1);\n}\n.toggle-play.pause {\n\theight: 15px;\n\twidth: 20px;\n\tcursor: pointer;\n\tposition: relative;\n}\n.toggle-play.pause:before {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 5px;\n\tbackground: white;\n\tcontent: '';\n\theight: 15px;\n\twidth: 3px;\n}\n.toggle-play.pause:after {\n\tposition: absolute;\n\ttop: 0;\n\tright: 0px;\n\tbackground: white;\n\tcontent: '';\n\theight: 15px;\n\twidth: 3px;\n}\n.toggle-play.pause:hover {\n\ttransform: scale(1.1);\n}\n.time {\n\tcolor: black;\n\tfont-weight: 700;\n\tmargin-top: 0;\n\tposition: absolute;\n\tleft: 50%;\n\ttop: 50%;\n\ttransform: translate(-50%, -50%);\n\tdisplay: flex;\n\tz-index: 125;\n\tpointer-events: none;\n\tbackground-color: transparent;\n\tborder-radius: 0;\n\tpadding: 0;\n}\n.time > * {\n\tpadding: 2px;\n}\n\n.volumeSliders {\n\tposition: absolute;\n\tbottom: 10px;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\tz-index: 100;\n\tdisplay: flex;\n\tjustify-content: center;\n\tgap: 70px;\n\tborder-radius: 5px;\n\twidth: 80%;\n\tpointer-events: auto;\n}\n\n#sfx-slider, #vol-slider {\n\tflex: 1;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tmax-width: 150px;\n\tmargin-bottom: 70px;\n}\n\n.volume-label {\n\tcolor: white;\n\tfont-size: 15px;\n\tmargin-bottom: 2px;\n\ttext-align: center;\n}\n\ninput#sfx.slider, input#vol.slider {\n\t-webkit-appearance: none;\n\twidth: 100%;\n\theight: 18px;\n\tcursor: pointer;\n\tmargin: 0;\n\tpadding: 0;\n}\n\ninput#sfx.slider::-webkit-slider-thumb, input#vol.slider::-webkit-slider-thumb {\n\t-webkit-appearance: none;\n\twidth: 18px;\n\theight: 18px;\n\tbackground: #9f0505;\n\tborder-radius: 50%;\n\tcursor: pointer;\n}\n\ninput#sfx.slider::-moz-range-thumb, input#vol.slider::-moz-range-thumb {\n\twidth: 18px;\n\theight: 18px;\n\tbackground: #9f0505;\n\tborder-radius: 50%;\n\tcursor: pointer;\n\tborder: none;\n}\n\ninput {\n\tbackground: transparent;\n}\n\n.audio-player-skin {\n\tposition: relative;\n}\n\n/* debug controls not working */\n.timeline-control, .toggle-play, .musicgenres__title {\n\tpointer-events: auto;\n\tz-index: 110; \n\tposition: relative;\n}\n\n.musicgenres__items {\n\tposition: absolute;\n\tz-index: 110;\n\tpointer-events: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
